import { requireAuth } from '@/features/auth/guards/require-auth'
import { projectsListQuery } from '@/features/projects/queries/projects-query'
import { receiptDetailQuery } from '@/features/receipts/queries/receipt-detail-query'
import { materialCatalogQuery } from '@/features/references/queries/material-catalog-query'
import { warehousesListQuery } from '@/features/references/warehouses/queries/warehouse-query'
import { StockReceiptEditorPage } from '@/features/stock-receipts/pages/stock-receipt-editor-page'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'
import * as z from 'zod'

const paramsSchema = z.object({
  stockReceiptId: z.coerce.number().int().positive(),
})

export const Route = createFileRoute('/_app/stock-receipts/$stockReceiptId')({
  beforeLoad: requireAuth,
  parseParams: paramsSchema.parse,
  stringifyParams: ({ stockReceiptId }) => ({ stockReceiptId: String(stockReceiptId) }),
  loader: async ({ params, context }) => {
    const qc = context.queryClient
    const receipt = await qc.ensureQueryData(receiptDetailQuery(params.stockReceiptId))
    await Promise.all([
      qc.ensureQueryData(projectsListQuery()),
      qc.ensureQueryData(warehousesListQuery()),
    ])
    if (receipt.project_id != null) {
      await qc.ensureQueryData(materialCatalogQuery(receipt.project_id))
    }
    return { number: receipt.number || `R-${String(receipt.id).padStart(4, '0')}` }
  },
  // Crumb: «<список> › <номер документа>» — the number from the loader, not the id.
  staticData: {
    crumbParent: { label: messages.crumbs.stockReceipts, to: '/stock-receipts/' },
    crumb: (m: { loaderData?: { number: string } }) => m.loaderData?.number ?? '…',
  },
  component: () => {
    const { stockReceiptId } = Route.useParams()
    return <StockReceiptEditorPage stockReceiptId={stockReceiptId} />
  },
})
